<template>
<div class="about-area">
   <div class="container">
       <div class="row">
            <div class="col-lg-12">
                    <div class="trending-tittle">
                    </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <!-- Trending Tittle -->
                <div class="about-right mb-90">
                    <div class="section-tittle mb-30 pt-30">
                        <h3 style="text-align: center;">{{detail.TieuDe}}</h3>
                    </div>
                    <div class="about-prea" style="text-align: justify;" v-html="detail.NoiDung">
                    </div>
                </div>
            </div>
            <div class="col-lg-4"></div>
        </div>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
import News from "@/common/api/news"
export default {
  props: ["id"],
  name: 'News',
  mixins: [mixin],
  data () {
    return {
        detail: {},
    }
  },
  created() {
     this.getNews()
  },
  methods: {
    getNews(){
        News.get(this.id).then(({ data }) => {
            this.detail = data.Data
        })
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/News/Index.vue